
export default function EventHead({ cover, name, behaviour }){
    return(
        <div className="event-head">
            <img className={"event-cover " + behaviour} src={cover} alt="event cover" onError={e=> e.currentTarget.src = '/media/images/landing-album.jpg'}/>
            <div className="coverOverlay"></div>
            <h2 className="event-name">{ name.split('\n').map((line, i)=> <> { i > 0 && <br/> }<span>{ line }</span> </>) }</h2>
        </div>
    )
}